export default "__VITE_ASSET__BMJtgEbC__"